export const SubscriptionsEndpoints = {
  getMetaplans: 'getMetaplans',
  createMetaplan: 'createMetaplan',
  updateMetaplan: 'updateMetaplan',
  deleteMetaplan: 'deleteMetaplan',
} as const;

export const BASE_SUBSCRIPTIONS_URL = '/v1/stores/subscriptions';
export const GET_METAPLANS_URL = `${BASE_SUBSCRIPTIONS_URL}/metaplans`;
export const CREATE_METAPLAN_URL = `${BASE_SUBSCRIPTIONS_URL}/metaplans`;
export const UPDATE_METAPLAN_URL = `${BASE_SUBSCRIPTIONS_URL}/metaplans/:metaplanId`;
export const DELETE_METAPLAN_URL = `${BASE_SUBSCRIPTIONS_URL}/metaplans/:metaplanId`;

export const subscriptionsTags = {
  metaplansList: 'metaplansList',
} as const;
